import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { useAirlineServices, useAirportConsultancy, useCommercialLeasing } from "./BusinessOppurtunities.hook";
import { fields } from "./constants";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { AirlineServices } from "./AirlineServices/AirlineServices";
import { AirportConsultancyAndOverseasVentures } from "./AirportConsultancyAndOverseasVentures/AirportConsultancyAndOverseasVentures";
import { CommericialLeasingOppurtunites } from "./CommericialLeasingOppurtunites/CommericialLeasingOppurtunites";
import { Icon } from "@iconify/react";
import { CommercialLeasingOpportunitiesTabs } from "./CommericialLeasingOppurtunites/CommercialLeasingOpportunitiesDynamicTabs/CommercialLeasingOpportunitiesTabs";
import { CommericialLeasingOppurtunitesPageContent } from "./CommericialLeasingOppurtunites/CommericialLeasingOppurtunitesPageContent";
import { CommericialLeasingOppurtunitesList } from "./CommericialLeasingOppurtunites/CommercialLeasingOpportunitiesList";


export const BusinessOppurtunities = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  useEffect(() => {
    if (!query.get("activeTab")) {
        navigate(`/dedicated/corporate/business-oppurtunities?activeTab=airlineServices`, {
          replace: true,
        });
    }
  }, []);

  const items = [
    {
      label: "Airline Services",
      key: "airlineServices",
      children: <AirlineServices/>
    },
    {
      label: "Airport Consultancy & Overseas Ventures",
      key: "airportConsultancy",
      children:<AirportConsultancyAndOverseasVentures/>
    },
    {
      label: "Commercial Leasing Opportunities Details",
      key: "commercialLeasingOpportunities",
      children: <CommercialLeasingOpportunitiesTabs /> // CommericialLeasingOppurtunites
    },
    {
      label: "Commercial Leasing Opportunities List",
      key: "commercialLeasingOpportunitiesList",
      children: <CommericialLeasingOppurtunitesList />
    },
  ];

  const handleButton = (activeTab:any, subActiveTab:any, thirdChildActiveTab:any)=>{
    if(activeTab==='commercialLeasingOpportunitiesList' && subActiveTab === "othersList"){
      return(<Button onClick={()=>{
        navigate('/dedicated/corporate/business-opportunities/commercialLeasingOpportunities/othersList/add')
      }}
      icon={<Icon icon={"lucide:plus"} />}
    >
      Add Others List     
    </Button>)
    } else if(activeTab==='commercialLeasingOpportunitiesList' && subActiveTab === "serviceOutletList"){
      return(<Button onClick={()=>{
        navigate('/dedicated/corporate/business-opportunities/commercialLeasingOpportunities/serviceOutletList/add')
      }}
      icon={<Icon icon={"lucide:plus"} />}
    >
      Add Service Outlet List    
    </Button>)
    } else if(activeTab==='commercialLeasingOpportunitiesList' && subActiveTab === "foodAndBeverageList"){
      return(<Button onClick={()=>{
        navigate('/dedicated/corporate/business-opportunities/commercialLeasingOpportunities/foodAndBeverageList/add')
      }}
      icon={<Icon icon={"lucide:plus"} />}
    >
      Add Food & Beverage List      
    </Button>)
    } else if(activeTab==='commercialLeasingOpportunitiesList' && subActiveTab === "retailOutletList"){
      return(<Button onClick={()=>{
        navigate('/dedicated/corporate/business-opportunities/commercialLeasingOpportunities/retailOutletList/add')
      }}
      icon={<Icon icon={"lucide:plus"} />}
    >
      Add Retail Outlet List    
    </Button>)
    } 
    else if(activeTab==='airlineServices' && subActiveTab==='airlineServicesFacilities' && thirdChildActiveTab==='airlineServicesFacilitiesPageContent'){
      return(<Button onClick={()=>{
        navigate('/dedicated/corporate/business-oppurtunities/airlineServices/airlineServicesFacilities/add')
      }}
      icon={<Icon icon={"lucide:plus"} />}
    >
        Add Airline Services Facilitites      
      </Button>)
    }
  }

  return (
    <ContentWrapper
      title={"Business Opportunities"}
      actionItems={handleButton(query.get('activeTab'), query.get('subActiveTab'), query.get('thirdChildActiveTab'))}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
